import React from "react"
import Layout from "../components/Layout/Layout"
import NewsHero from "../components/NewsMedia/NewsHero"
import Seo from "../utils/Seo"
import NewsSocial from "../components/NewsMedia/NewsSocial"
import HomeBanner from "../components/NewsMedia/HomeBanner"
// import NewsScrollCard from "../components/NewsScrollCard"

import { graphql } from "gatsby"

const DaliaMedia = ({ data, location }) => {
  const companiesLogo = data.allStrapiPageHome.nodes[0]

  return (
    <Layout
      type="navbar"
      location={location}
      background="black"
      lines="#FF8900"
    >
      <Seo
        seo={{
          metaDescription: "Dalia Talks",
          metaSubtitle: "Smart Content for Powerful Women.",
        }}
      />
      <NewsHero />
      <NewsSocial />
      <HomeBanner companiesLogo={companiesLogo} />
      {/* <NewsScrollCard /> */}
    </Layout>
  )
}

export const query = graphql`
  query MyQueryNewsMedia($language: String!) {
    strapiPageNewsMedia {
      heroButton
      ctaButton
      ctaDescription
      ctaSubtitle
      ctaTitle
      ctaImage {
        localFile {
          childImageSharp {
            gatsbyImageData(layout: CONSTRAINED)
          }
        }
      }
    }
    allStrapiPageHomeHeroSlider {
      nodes {
        sliderTitle
        sliderSubtitle
        sliderButton
      }
    }
    allStrapiPageHome {
      nodes {
        heroImage {
          localFile {
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED)
            }
          }
          alternativeText
        }
        companyLogos {
          localFile {
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED)
            }
          }
          alternativeText
          caption
        }
        alliesLogos {
          alternativeText
          localFile {
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED)
            }
          }
        }
        gridImage1 {
          alternativeText
          localFile {
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED)
            }
          }
        }
        gridImage2 {
          alternativeText
          localFile {
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED)
            }
          }
        }
        gridImage3 {
          alternativeText
          localFile {
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED)
            }
          }
        }
        ctaImage1 {
          alternativeText
          localFile {
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED)
            }
          }
        }
        ctaImage2 {
          alternativeText
          localFile {
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED)
            }
          }
        }
        ctaImage3 {
          alternativeText
          localFile {
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED)
            }
          }
        }
      }
    }
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`

export default DaliaMedia
